//used for ad earnings table columns
export const TRANSACTIONS_COLUMNS = [
  {
    Header: "Date Of Payout",
    accessor: "paidAt",
  },
  {
    Header: "Bundle ID",
    accessor: "bundleId",
  },
  {
    Header: "Total",
    accessor: "userShareTotal",
  },
  // {
  //   Header: "Revenue Share",
  //   accessor: "revSharePercentage",
  // },
  {
    Header: "Transaction ID",
    accessor: "id",
  },
];

export const METRICS_BY_DAY_TOTALS_COLUMNS = [
  {
    Header: "Bundle ID",
    accessor: "bundleId",
  },
  {
    Header: "OS",
    accessor: "os",
  },
  {
    Header: "Revenue",
    accessor: "revenue",
  },
  {
    Header: "Impressions",
    accessor: "impressions",
  },
  {
    Header: "ECPM",
    accessor: "ecpm",
  },
];

export const METRICS_BY_DAY_ITEMS_COLUMNS = [
  {
    Header: "Date",
    accessor: "date",
  },
  {
    Header: "Bundle ID",
    accessor: "bundleId",
  },
  {
    Header: "OS",
    accessor: "os",
  },
  {
    Header: "Revenue",
    accessor: "revenue",
  },
  {
    Header: "Impressions",
    accessor: "impressions",
  },
  {
    Header: "ECPM",
    accessor: "ecpm",
  },
];